class JLFBoutiques extends HTMLElement {
  connectedCallback() {
    this.cards = Array.from(this.querySelectorAll('[data-jlf-boutique-card]'));
    this.triggers = Array.from(this.querySelectorAll('[data-jlf-boutique-trigger]'));
    this.mobileAreas = Array.from(this.querySelectorAll('[data-jlf-mobile-area]'));

    this.triggers.forEach((trigger) => {
      trigger.addEventListener('click', this.handleTrigger);
    });

    this.mobileAreas.forEach((area) => {
      area.addEventListener('click', this.handleMobileArea);
    });

    if (!this.cards.some((card) => card.classList.contains('is-active')) && this.cards[0]) {
      this.setActive(this.cards[0]);
    }

  }

  disconnectedCallback() {
    this.triggers?.forEach((trigger) => {
      trigger.removeEventListener('click', this.handleTrigger);
    });

    this.mobileAreas?.forEach((area) => {
      area.removeEventListener('click', this.handleMobileArea);
    });
  }

  handleTrigger = (event) => {
    if (window.matchMedia('(max-width: 749px)').matches) return;
    const card = event.currentTarget.closest('[data-jlf-boutique-card]');
    if (card) this.setActive(card);
  };

  handleMobileArea = (event) => {
    if (!window.matchMedia('(max-width: 749px)').matches) return;
    const activeArea = event.currentTarget;
    const shouldClose = activeArea.classList.contains('is-active');
    this.setActiveMobileArea(shouldClose ? null : activeArea);
  };

  setActive(activeCard) {
    this.cards.forEach((card) => {
      const isActive = card === activeCard;
      card.classList.toggle('is-active', isActive);
      card.querySelector('[data-jlf-boutique-trigger]')?.setAttribute('aria-expanded', String(isActive));
    });
  }

  setActiveMobileArea(activeArea) {
    this.mobileAreas.forEach((area) => {
      const isActive = area === activeArea;
      area.classList.toggle('is-active', isActive);
      area.setAttribute('aria-expanded', String(isActive));
    });
  }
}

if (!customElements.get('jlf-boutiques')) {
  customElements.define('jlf-boutiques', JLFBoutiques);
}
